import { render, staticRenderFns } from "./CardPackagingIcon.vue?vue&type=template&id=c3fa9dfc&scoped=true"
import script from "./CardPackagingIcon.vue?vue&type=script&lang=js"
export * from "./CardPackagingIcon.vue?vue&type=script&lang=js"
import style0 from "./CardPackagingIcon.vue?vue&type=style&index=0&id=c3fa9dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fa9dfc",
  null
  
)

export default component.exports